import { Component, AfterViewInit, ViewChild, ElementRef, Input } from '@angular/core';

declare var H: any;
declare var google: any;
@Component({
  selector: 'client-address-map',
  templateUrl: './client-address-map.component.html'
})
export class ClientAddressMapComponent implements AfterViewInit {

  constructor() {
  }

  ngAfterViewInit(): void {
  }
}
